import * as React from 'react';

import {AccentBorder} from '../accent-border/accent-border';
import {Card} from '../card/card';
import {colors} from '../colors/colors';

import {TwoRowItem} from './two-row-item';
import type {Props as TwoRowItemProps} from './two-row-item';

export function TwoRowItemCard(props: TwoRowItemProps) {
    // Needed because TwoRowItem needs an exact set of props
    const sealedProps = Object.freeze({...props});

    return (
        <Card hasBorder={true}>
            <AccentBorder color={colors.green}>
                {React.createElement(TwoRowItem, sealedProps)}
            </AccentBorder>
        </Card>
    );
}
